import { Injectable } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Injectable({
  providedIn: 'root'
})
export class GtmService {

  tracking_systems_dataLayerTemplates: any = {
    viewPage: (url: string) => {
      return {
        event: 'page',
        pageName: url
      }
    }
  };

  constructor(
    private gtmService: GoogleTagManagerService
  ) { }

  /**urlTag: {nombre de evento, url de evento} */
  pageView(url: string) {
    const gtmTag = this.tracking_systems_dataLayerTemplates['viewPage'](url);
    this.gtmService.pushTag(gtmTag).catch(() => {});
  }
}